import React, { useState, useRef, useEffect } from 'react';

const ListeningAudio = ({ jsonPath, nextRoute }) => {
  const [audioSrc, setAudioSrc] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [audioEnded, setAudioEnded] = useState(false);
  const [audioStarted, setAudioStarted] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    const loadData = async () => {
      const res = await fetch(jsonPath);
      const data = await res.json();
      setAudioSrc(data.audio);
      setImageSrc(data.imageSrc || null);
    };
    loadData();
  }, [jsonPath]);

  const handlePlay = () => {
    if (audioRef.current && !audioStarted) {
      audioRef.current.play();
      setAudioStarted(true);
    }
  };

  const handleAudioEnd = () => {
    setAudioEnded(true);
  };

  const handleContinue = () => {
    if (audioEnded) {
      window.location.href = nextRoute;
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto text-center">
      <h1 className="text-2xl font-semibold mb-4">Listening Passage</h1>

      {!audioSrc ? (
        <p>Loading audio...</p>
      ) : (
        <>
          {imageSrc && (
            <img
              src={imageSrc.startsWith('http') ? imageSrc : `/images/${imageSrc}`}
              alt="Listening Illustration"
              className="mb-6 mx-auto max-h-64 object-contain"
            />
          )}

          <p className="mb-4 text-gray-700">
            Please listen to the full passage carefully. Take notes as you listen. You will not be able to listen again once it ends.
          </p>

          <audio
            ref={audioRef}
            src={audioSrc}
            onEnded={handleAudioEnd}
            className="hidden" // 🌟 hide the default controls
          />

          {!audioStarted ? (
            <button
              onClick={handlePlay}
              className="mt-6 px-6 py-2 rounded-lg text-white bg-blue-600 hover:bg-blue-700"
            >
              Start Listening
            </button>
          ) : (
            <p className="mb-4 text-green-600 font-semibold"><span role="img" aria-label="speaker high volume">🔊</span>
 Listening in progress...</p>
          )}

          <button
            onClick={handleContinue}
            disabled={!audioEnded}
            className={`mt-6 px-6 py-2 rounded-lg text-white ${
              audioEnded ? 'bg-green-600 hover:bg-green-700' : 'bg-gray-400 cursor-not-allowed'
            }`}
          >
            {audioEnded ? 'Continue to Questions' : 'Listen to Continue'}
          </button>
        </>
      )}
    </div>
  );
};

export default ListeningAudio;
